import { ExclamationCircleIcon } from '@heroicons/react/outline'
import { useTranslation } from 'react-i18next'
import { InformationCard } from '../../../../components'
import { areaTone, areaIcon, operatorHeadline, isRetryableFlag } from '../../../../utils/fulfillmentErrorPresentation'

const getActiveErrors = fulfillmentErrors => {
  if (!Array.isArray(fulfillmentErrors)) return []
  return fulfillmentErrors.filter(e => e.error_status === 'open' || e.error_status === 'pending_retry')
}

const FulfillmentErrorBannerSection = ({ fulfillmentErrors }) => {
  const { i18n } = useTranslation()

  const error = getActiveErrors(fulfillmentErrors)[0]
  if (!error) return null

  // pending_retry is the one thing the banner knows and the card does not: the store already fixed it and
  // the operator can try again without waiting for anyone.
  if (error.error_status === 'pending_retry') {
    return (
      <InformationCard
        title={i18n.t('fulfillment_errors.packing_banner.title')}
        description={i18n.t('fulfillment_errors.packing_banner.pending_retry')}
        iconComponent={<ExclamationCircleIcon className="h-full" />}
        containerStyles="bg-blue-100 text-blue-700"
      />
    )
  }

  // For everything else, the banner repeats the card's instruction and colour. When it
  // derived its own, the same error said "Pasa a la siguiente orden" on the card and
  // "Escala a tu supervisor" down here.
  const tone = areaTone(error.responsible_area)
  const AreaIcon = areaIcon(error.responsible_area)
  // The banner has no clock: it lives on the page, not in the moment of the attempt. For
  // actions with a wait it takes the patient form ("Espera y reintenta"), which never contradicts
  // the card —a "Reintenta ahora" down here while the countdown runs above would—.
  const areaLabel = error.responsible_area
    ? i18n.t(`fulfillment_errors.responsible_area.${error.responsible_area}`, { defaultValue: error.responsible_area })
    : null
  const headline = operatorHeadline(i18n, {
    flagType: error.flag_type,
    waiting: isRetryableFlag(error.flag_type),
    areaLabel,
  })

  return (
    <InformationCard
      title={i18n.t('fulfillment_errors.packing_banner.title')}
      description={headline}
      iconComponent={<AreaIcon className="h-full" />}
      containerStyles={tone.tile}
    />
  )
}

export default FulfillmentErrorBannerSection
